module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-search",
    class: {
      loading: _vm.list.loading
    }
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.parameters.keywords),
      expression: "parameters.keywords",
      modifiers: {
        "trim": true
      }
    }],
    ref: "searchInput",
    attrs: {
      "type": "text",
      "placeholder": "Indtast søgeord..."
    },
    domProps: {
      "value": (_vm.parameters.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.parameters, "keywords", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [(_vm.messageStatus) ? _c('div', {
    staticClass: "search-message",
    domProps: {
      "innerHTML": _vm._s(_vm.messageStatus)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.list.results.items), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      staticClass: "title",
      attrs: {
        "href": item.url
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.name ||  item.title ||  item.titel) + "\n\t\t\t\t")]), _vm._v(" "), (item.teaser && item.teaser.length > 0) ? _c('p', {
      staticClass: "teaser"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.teaser) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('small', {
      staticClass: "meta"
    }, [_c('a', {
      staticClass: "url",
      attrs: {
        "href": item.url
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.url) + "\n\t\t\t\t\t")])])])
  }))]), _vm._v(" "), (_vm.list.results.pagination.total > _vm.list.results.items.length) ? _c('div', {
    staticClass: "search-more"
  }, [_c('button', {
    staticClass: "search-previous",
    on: {
      "click": _vm.previous
    }
  }, [(_vm.list.preferences.pagination && _vm.list.results.pagination.offset != 0) ? _c('span', [_c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  }), _vm._v("\n\t\t\t\tForrige\n\t\t\t")], 1) : _vm._e()]), _vm._v(" "), _c('ul', _vm._l((Math.ceil(_vm.list.results.pagination.total / _vm.list.params.limit)), function(n) {
    return _c('li', {
      class: {
        active: _vm.numNavActiveClass(n)
      },
      domProps: {
        "textContent": _vm._s(n)
      },
      on: {
        "click": function($event) {
          _vm.toPage(n * _vm.list.params.limit - _vm.list.params.limit)
        }
      }
    })
  })), _vm._v(" "), _c('button', {
    staticClass: "search-next",
    on: {
      "click": _vm.next
    }
  }, [(_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('span', [_vm._v("\n\t\t\t\tNæste\n\t\t\t\t"), _c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  })], 1) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-f5e19170"}!./scripts/sky-search/sky-search.html
// module id = 389
// module chunks = 1